import React from 'react';
import PropTypes from 'prop-types';
import MemberStore from '../../stores/MemberStore';
import ImageSvg from '../images/ImageSvg.react';
import get from 'lodash/get';

const ReactPropTypes = PropTypes;

class MemberName extends React.Component {
	static propTypes = {
	  memberId: ReactPropTypes.string,
	  truncate: ReactPropTypes.number,
	  className: ReactPropTypes.string,
	};

	static defaultProps = {
	  memberId: null,
	  truncate: 12,
	  hideAnswerScore: false,
	  className: '',
	};

	state = {
	  member: MemberStore.get(this.props.memberId),
	};

	render() {
	  if (!this.state.member) {
	    return (<span />);
	  }

	  let memberAge = '';
	  let name = '';
	  const member = this.state.member;
	  let memberAnswerScore = '';
	  const status = member.status;
	  const hideAnswerScore = this.props.hideAnswerScore;

	  // deleted vai admin
	  if (['deleted', 'admin'].indexOf(status) !== -1) {
      switch (status) {
        case 'deleted':
          name = get(translations, 'txt: Dzēsts lietotājs', '');
          break;
        case 'admin':
          name = get(globals, 'currentDomainName', '');
          break;
        default:
          name = status;
      }
	    // name = get(translations, status, '');
	  }
	  // active lietotājs
	  else {
	    name = member.name;
	    // garos vārdus saīsina
	    if (name !== null && name.length > this.props.truncate) {
	      name = `${name.substring(0, this.props.truncate - 1)}...`;
	    }

	    // gadi
	    if (member.age) {
	      memberAge = `(${member.age})`;
	    }

	    // anketas procenti
	    memberAnswerScore = `${get(translations, 'txt: Anketa', '')}: ${member.answer_score} %`;
	  }
	  let className = '';
	  if (this.props.className) {
	    className += ` ${this.props.className}`;
	  }

	  let answerClassName = 'memberAnswerScore g';
	  if (['deleted', 'admin'].indexOf(status) !== -1) {
	    answerClassName += ' hiddenAnswerScore';
	    className += ' hasHiddenAnswerScore';
	  }

	  const memberAnswerScoreDiv = function () {
	    if (hideAnswerScore == true) {
	      return ('');
	    }

	    return (
  <span className={answerClassName}>
    <span className="btn-static">
      <ImageSvg svg="icon-notes" iconClass="icon--center icon--notes" />
    </span>
    {memberAnswerScore}
  </span>
	    );
	  };

	  return (
  <span className={className}>
    <span className="memberName-name">{name}</span>
    <span className="memberName-age"> {memberAge}</span>
    {memberAnswerScoreDiv()}
  </span>
	  );
	}
}

module.exports = MemberName;
